import type { DeviceFrame } from '@/store/useApp';

const FRAME_WIDTHS: Record<DeviceFrame, string> = {
  desktop: '100%',
  tablet: '820px',
  mobile: '390px',
};

export function deviceFrameWidth(frame: DeviceFrame): string {
  return FRAME_WIDTHS[frame];
}
